// map of progress status codes -> ProgressCircle types

export const PROGRESS_TYPES = {
  'in-progress': 'running',
  done: 'safe',
  error: 'danger',
};
